"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLAT_ROOF_SPECIFICATIONS = void 0;
const flat_roof_specifications_json_1 = __importDefault(require("../generator/flat_roof_specifications.json"));
exports.FLAT_ROOF_SPECIFICATIONS = flat_roof_specifications_json_1.default;
